<template>
  <div
    class="field-item-row"
  >
    <label>{{ $t('message["1412"]') }}</label>
    <div class="field-item-cell">
      <div class="tree-list">
        <a-tree
          draggable
          :default-expanded-keys="[]"
          :expanded-keys="expandedKeys"
          :tree-data="treeDatas"
          :selectable="false"
          :auto-expand-parent="autoExpandParent"
          @expand="onExpand"
          @select="onSelect"
          @drop="onDrop"
        >
          <template
            slot="key"
            slot-scope="{title}"
          >
            <OperaTreeNode
              :item-data="title"
              :datas="datas"
              :options="treeDatas"
              @delTreeItem="delTItem"
            />
          </template>
        </a-tree>
      </div>
      <div
        v-if="NoSelectTreeDatas.length"
        class="field-item-tip"
      >
        <a-button
          @click="addItem"
        >
          {{ $t('message["1198"]') }}
        </a-button>
        <add-tree-item-dialog
          ref="addItemDialog"
          :options="NoSelectTreeDatas"
          :data="datas.options"
          :checked-data="checkedArr"
        />
        <em>{{ $t('message["181"]') }}</em>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import OperaTreeNode from './OperaTreeNode'
import AddTreeItemDialog from './AddTreeItem'
import { cloneDeep } from 'lodash'
const dataList = []
const generateList = (data) => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i]
    const key = node.key
    dataList.push({ key, title: { title: data[i].title.title } })
    if (node.children) {
      generateList(node.children, node.key)
    }
  }
}
export default {
  components: {
    OperaTreeNode,
    AddTreeItemDialog
  },
  props: {
    datas: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    this.datas.defaultvalue.forEach(item => {
      this.loopCheckDatas(this.datas.options, item)
    })
    this.loop(this.datas.options)
    return {
      expandedKeys: [],
      searchValue: '',
      defaultExpandParent: [],
      autoExpandParent: false,
      checkedArr: []
    }
  },
  computed: {
    ...mapState('universalForm/form', ['infoDatas', 'formDefaultDatas']),
    treeDatas () {
      return this.convert(cloneDeep(this.datas.options))
    },
    NoSelectTreeDatas () {
      return this.convert2(cloneDeep(this.datas.options))
    }
  },
  watch: {
    datas: {
      handler (val) {
        this.datas.defaultvalue.forEach(item => {
          this.loopCheckDatas(this.datas.options, item)
        })
        this.loop(this.datas.options)
        generateList(this.datas.options)
      },
      deep: true
    }
  },
  mounted () {
    // this.datas.defaultvalue.forEach(item => {
    //   this.loopCheckDatas(this.datas.options, item)
    // })
    // this.loop(this.datas.options)
  },
  methods: {
    addItem () {
      this.$refs.addItemDialog.changeVisible(true)
      this.loopDisabledData(this.NoSelectTreeDatas, this.checkedArr)
    },
    onSelect (selectedKeys, info) {
      // console.log('selected', selectedKeys, info)
    },
    onDrop (info) {
      const dropKey = info.node.eventKey
      const dragKey = info.dragNode.eventKey
      const dropPos = info.node.pos.split('-')
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1])
      const loop = (data, key, callback) => {
        data.forEach((item, index, arr) => {
          if (item.key === key) {
            return callback(item, index, arr)
          }
          if (item.children) {
            return loop(item.children, key, callback)
          }
        })
      }
      const data = [...this.datas.options]

      // Find dragObject
      let dropObj
      loop(data, dropKey, (item, index, arr) => {
        dropObj = item
      })
      let dragObj
      loop(data, dragKey, (item, index, arr) => {
        // if (item.pid === dropObj.pid) {
        //   arr.splice(index, 1)
        // }
        dragObj = item
      })
      if (dragObj.pid === dropObj.pid) {
        if (!info.dropToGap) {
          // Drop on the content
          // loop(data, dropKey, (item) => {
          //   item.children = item.children || []
          //   // where to insert 示例添加到尾部，可以是随意位置
          //   item.children.push(dragObj)
          // })
        } else if (
          (info.node.children || []).length > 0 && info.node.expanded && dropPosition === 1 // On the bottom gap
        ) {
          // loop(data, dropKey, (item) => {
          //   item.children = item.children || []
          //   // where to insert 示例添加到尾部，可以是随意位置
          //   item.children.unshift(dragObj)
          // })
        } else {
          loop(data, dragKey, (item, index, arr) => {
            if (item.pid === dropObj.pid) {
              arr.splice(index, 1)
            }
          })
          let ar
          let i
          loop(data, dropKey, (item, index, arr) => {
            ar = arr
            i = index
          })
          if (dropPosition === -1) {
            ar.splice(i, 0, dragObj)
          } else {
            ar.splice(i + 1, 0, dragObj)
          }
        }
      }
      // this.treeDatas = data
      this.datas.options = data
      // this.setTreeData(data)
    },
    onExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    loop (arr, pid) {
      arr.forEach((item, index) => {
        item['scopedSlots'] = { title: 'key' }
        item['key'] = item.id
        item['pid'] = pid
        item.title = {
          title: item.showname || item.name,
          // item: item
          key: item.id,
          name: item.name,
          pid: pid,
          ischecked: item.ischecked
        }
        if (item.children && item.children.length > 0) {
          this.loop(item.children, item.id)
        }
      })
    },
    convert (arr) {
      const newArr = arr.filter(item => item.isshow
      // {
      //   if (item.isshow) {
      //     item['scopedSlots'] = { title: 'key' }
      //     item['key'] = item.id
      //     item['pid'] = pid
      //     item.title = {
      //       title: item.showname || item.name,
      //       // item: item
      //       key: item.id,
      //       name: item.name,
      //       pid: pid,
      //       ischecked: item.ischecked
      //     }
      //     return item
      //   }
      // }
      )
      return newArr.map(item => {
        if (item.children) {
          item.children = this.convert(item.children)
        }
        return item
      })
    },
    isDeleted (item) {
      if (!item.isshow) {
        return true
      }
      const { children } = item
      if (!children) {
        return false
      }
      const { length } = children
      for (let i = 0; i < length; i++) {
        const child = children[i]
        while (this.isDeleted(child)) {
          return true
        }
      }
      return false
    },
    convert2 (arr) {
      function isDeleted (item) {
        if (!item.isshow) {
          return true
        }
        const { children } = item
        if (!children) {
          return false
        }
        const { length } = children
        for (let i = 0; i < length; i++) {
          const child = children[i]
          while (isDeleted(child)) {
            return true
          }
        }
        return false
      }
      return arr
        .filter(item => isDeleted(item)
        // {
        //   if (isDeleted(item)) {
        //     item['scopedSlots'] = { title: 'key' }
        //     item['key'] = item.id
        //     item['pid'] = pid
        //     item.title = {
        //       title: item.showname || item.name,
        //       // item: item
        //       key: item.id,
        //       name: item.name,
        //       pid: pid,
        //       ischecked: item.ischecked
        //     }
        //     return item
        //   }
        // }
        )
        .map(item => {
          // let arr = []
          if (item.children) {
            item.children = this.convert2(item.children)
          }
          return item
        })
    },
    loopCheckDatas (arr, key) {
      // debugger
      arr.forEach(item => {
        if (item.id === key) {
          this.$set(item, 'ischecked', true)
        }
        if (item.children && item.children.length > 0) {
          this.loopCheckDatas(item.children, key)
        }
      })
    },
    loopDisabledData (arr, checkedArr) {
      arr.forEach(item => {
        if (item.isshow) {
          if (checkedArr.indexOf(item.key) === -1) {
            checkedArr.push(item.key)
          }
          if (item.level === 1 || (item.level === 2)) {
            // item.disableCheckbox = true
            this.$set(item, 'disableCheckbox', true)
          }
        } else {
          if (checkedArr.indexOf(item.key) > -1) {
            checkedArr.splice(checkedArr.indexOf(item.key), 1)
          }
        }
        if (item.children && item.children.length > 0) {
          this.loopDisabledData(item.children, checkedArr)
        }
      })
    },
    delTItem (datas) {
      // this.loop(this.datas.options, null)
      // this.datas.options = datas
    }
  }
}
</script>
<style lang="scss" scoped>
  .tree-list::v-deep {
    .ant-tree li .ant-tree-node-content-wrapper {
      height: 36px;
      line-height: 36px;
      padding: 0 16px;
    }
    .ant-tree li span[draggable], .ant-tree li span[draggable='true'] {
      line-height: 36px;
    }
    .ant-tree li span.ant-tree-switcher, .ant-tree li span.ant-tree-iconEle {
      height: 36px;
      line-height: 36px;
    }
    .ant-tree li .ant-tree-node-content-wrapper:hover,.ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
      background: #f4f7f9;
      .item-tree2 .op-tool {
        display:inline-block;
      }
    }
  }
</style>
